/* Adjust Sum Insured Upload Scan Page */

import axios from "axios";
import { collection, doc, onSnapshot, query } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { BASE_URL } from "../../../../api/baseURL";
import uploadfile from "../../../../assets/images/upload_file.svg";
import TitleDescription from "../../../../components/newMotorPolicy/titleDescription/titleDescription";
import { inspektlabsDB } from "../../../../firebase";
import useMotorFlow from "../../../../hooks/useMotorFlow";
import {
  getInspectionDocsUploaded,
  getInspectionFailed,
  getIsDamagePhotoTaken,
  setIsInspectionDocsUploaded,
  setIsInspectionFailed,
} from "../../../../redux/features/endorsements/cancellationSlice";
import { selectProfileData } from "../../../../redux/features/profileSlice";
import UploadSuccess from "./uploadSuccess";
// import Loader from '../../../../components/common/Loader/Loader';
import { toast } from "sonner";
import { Loader } from "storybook/internal/components";
import { getPolicyViewHeaderResponse } from "../../../../redux/features/policyDetailsSlice";

const UploadScanAdjustSumInsured = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { handleNextSubstep } = useMotorFlow();

  const [docsuploadedSuccess, setDocsuploadedSuccess] = useState(false);
  const [inspectionFail, setInspectionFail] = useState(false);

  const policyDetails = useSelector(getPolicyViewHeaderResponse);
  const userInfo = useSelector(selectProfileData);
  const getDocUploadStatus = useSelector(getInspectionDocsUploaded);
  const getInspectionFailedSatus = useSelector(getInspectionFailed);
  const getDamagePhotoTaken = useSelector(getIsDamagePhotoTaken);

  const [uploadStatus, setUploadStatus] = useState("");
  const [messageEn, setMessgeEn] = useState("");
  const [messageAr, setMessgeAr] = useState("");

  // Inspection conditions
  useEffect(() => {
    if (!policyDetails?.QuoteNumber) return;

    const q = query(collection(inspektlabsDB, "inspection-results"));
    const docRef = doc(
      inspektlabsDB,
      "inspection-results",
      policyDetails.QuoteNumber
    );

    dispatch(setIsInspectionDocsUploaded(false));
    dispatch(setIsInspectionFailed(false));

    const unsubscribe = onSnapshot(
      docRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          const status = data.status ?? "No Status"; // Assuming 'status' is the field name
          const uploadStatus = data.uploadStatus ?? "No Upload Status";
          const isDamagePhotoTaken =
            data.isDamagePhotoTaken ?? "No Damage Photo Taken";

          console.log("Current status:", status);
          // You can also set different messages based on status
          if (
            status.toLowerCase() === "completed" ||
            uploadStatus.toLowerCase() === "complete upload"
          ) {
            // toast.info(data.totalScore ?? "No score found");
            // toast.info(data.passDecision ?? "No pass decision found");
            // toast.info(data.isDamagePhotoTaken ?? "No damage photo taken found");

            if (data.isLicensePlateMismatch == true) {
              toast.error(
                "License Plate Mismatch! Please double check your license plate."
              );
              dispatch(setIsInspectionDocsUploaded(false));
              dispatch(setIsInspectionFailed(true));
            }

            if (
              data.passDecision &&
              (data.isLicensePlateMismatch == "" ||
                data.isLicensePlateMismatch == false)
            ) {
              dispatch(setIsInspectionDocsUploaded(true));
              dispatch(setIsInspectionFailed(false));
            } else {
              dispatch(setIsInspectionDocsUploaded(false));
              dispatch(setIsInspectionFailed(true));
            }
            // dispatch(setIsDamagePhotosTaken(isDamagePhotoTaken));

            setMessgeEn("Your inspection is complete!");
            setMessgeAr("اكتمل الفحص الخاص بك!");
          } else if (status.toLowerCase() === "pending") {
            // setDocsuploadedSuccess(false);
            dispatch(setIsInspectionDocsUploaded(false));
            dispatch(setIsInspectionFailed(false));
            setMessgeEn("Your inspection is being processed...");
            setMessgeAr("يتم معالجة الفحص الخاص بك...");
          } else if (status.toLowerCase() === "rejected") {
            // setDocsuploadedSuccess(false);
            dispatch(setIsInspectionDocsUploaded(false));
            // setInspectionFail(true);
            dispatch(setIsInspectionFailed(true));
            setMessgeEn("Your inspection is being processed...");
            setMessgeAr("يتم معالجة الفحص الخاص بك...");
          } else if (
            status.toLowerCase() === "incomplete" ||
            status.toLowerCase() === "incomplete upload"
          ) {
            // setDocsuploadedSuccess(false);
            dispatch(setIsInspectionDocsUploaded(false));
            // setInspectionFail(true);
            dispatch(setIsInspectionFailed(true));

            setMessgeEn("Your inspection is being processed...");
            setMessgeAr("يتم معالجة الفحص الخاص بك...");
          }
        } else {
          console.log("Document doesn't exist");
        }
      },
      (error) => {
        console.error("Error listening to document:", error);
      }
    );

    // Cleanup the listener on component unmount
    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (!policyDetails?.QuoteNumber || !userInfo?.PhoneNumber) return;
    console.log("Sending link with:", policyDetails.QuoteNumber);
    console.log("Sending link with number:", userInfo.PhoneNumber);

    const formattedPhone = userInfo.PhoneNumber.startsWith("973")
      ? userInfo.PhoneNumber
      : `973${userInfo.PhoneNumber}`;

    const requestBody = {
      caseId: policyDetails.QuoteNumber, // Policy Number as ID
      appType: "default", // Either "custom" or "default"
      appId: "2", // Fixed App ID
      userDetails: {
        phone: `+${formattedPhone}`,
        Email: userInfo.Email ?? "abdulrahman.janahi@solidarity.com.bh",
      },
      inputMetaData: {
        licensePlate: policyDetails?.RegistrationNumber ?? "No License Plate",
        infoCarCode: "",
        vin: "",
      },
    };

    axios
      .post(`${BASE_URL}/Inspektlabs/sendLink`, requestBody)
      .then((response) => {
        console.log("API Response:", response.data);
      })
      .catch((error) => {
        console.error("API Error:", error);
      });
  }, [policyDetails, userInfo]);

  /* Next */
  const NextHandler = () => {
    handleNextSubstep();
  };

  return (
    <div className="max-w-lg mx-auto bg-white rounded-md max767:w-[90%]">
      <div className="upload3rdPartyDocsPage">
        <TitleDescription
          title={t(
            "motorInsurance.newMotorInsuranceFlow.upload3rdPartyDocsPage.title"
          )}
          description={t(
            "motorInsurance.newMotorInsuranceFlow.upload3rdPartyDocsPage.description"
          )}
        />

        <div className="rounded-3xl p-6 mb-6">
          <div className="flex items-center mb-4"></div>
          <p className="text-gray-700 mb-4  px-8 py-0">
            {!getDocUploadStatus && !getInspectionFailedSatus && <Loader />}
          </p>
        </div>

        {getDocUploadStatus && (
          <UploadSuccess
            nexthandler={NextHandler}
            damageCondition={getDamagePhotoTaken}
          />
        )}
        {getInspectionFailedSatus && (
          <div className="bg-gray-100 p-6 rounded-3xl mb-4 min-h-[300px]">
            <div className="flex justify-around mb-4">
              <div className="bg-red-500 text-white p-3 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </div>
            </div>
            <h2 className="text-[#48535B] text-center text-2xl not-italic font-normal leading-[34px] tracking-[-0.24px] mb-2">
              {/* {translate("Congratulations on Successfully Uploading Your Photos!","أهنئك على تحميل صورك بنجاح!")} */}
              {t("motorInsurance.uploadFail.upload_failure")}
            </h2>
            <p className="text-gray-700 mb-6 text-left">
              {/* {translate("You have successfully uploaded photos of your car from all required angles. These images are crucial for assessing the current state of your vehicle as part of your insurance application.","لقد قمت بنجاح بتحميل صور لسيارتك من جميع الزوايا المطلوبة. هذه الصور ضرورية لتقييم الحالة الحالية لسيارتك كجزء من طلب التأمين الخاص بك.")} */}
              {t("motorInsurance.uploadFail.upload_photos")}
            </p>
          </div>
        )}

        {!getDocUploadStatus && !getInspectionFailedSatus && (
          <div className="bg-[#E3F8FF] rounded-3xl p-8 mb-6 min-h-[300px]">
            <div className="flex items-center mb-4">
              <div className="text-white rounded-full mr-2">
                <img src={uploadfile} alt="Back arrow" className="" />
              </div>
              <h2 className="text-lg font-semibold">
                {t(
                  "motorInsurance.newMotorInsuranceFlow.upload3rdPartyDocsPage.stepsToUpload.label"
                )}
              </h2>
            </div>
            <p className="text-gray-700 mb-4  px-8 py-0">
              {t(
                "motorInsurance.newMotorInsuranceFlow.upload3rdPartyDocsPage.stepsToUpload.description"
              )}{" "}
            </p>
          </div>
        )}
      </div>

      <div>
        <br></br>
        <br></br>
        <br></br>

        <p className="text-[#48535B] text-sm not-italic font-normal leading-5 tracking-[-0.14px] mb-4">
          {t(
            "motorInsurance.newMotorInsuranceFlow.upload3rdPartyDocsPage.needAssistance"
          )}{" "}
          <a
            href="/faqs"
            className="text-[#00384D] text-sm not-italic font-semibold leading-5 tracking-[-0.14px] underline"
          >
            {t(
              "motorInsurance.newMotorInsuranceFlow.upload3rdPartyDocsPage.faq"
            )}
          </a>{" "}
          {t(
            "motorInsurance.newMotorInsuranceFlow.upload3rdPartyDocsPage.sectionOr"
          )}{" "}
          <a
            href="/contact"
            className="text-[#00384D] text-sm not-italic font-semibold leading-5 tracking-[-0.14px] underline"
          >
            {t(
              "motorInsurance.newMotorInsuranceFlow.upload3rdPartyDocsPage.contactCustomerSupport"
            )}{" "}
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default UploadScanAdjustSumInsured;
